import { ConnectEmployeeTres } from "../../components/connectEmployeeTres";

export const ConnectEmployeePage = () => {

  
  return <ConnectEmployeeTres></ConnectEmployeeTres>;
};
